import { Component, EventEmitter, Input, OnInit, Output, ElementRef, ViewChild, ViewChildren, QueryList, Renderer2 } from '@angular/core';
import { EmployeeService } from '../employee-profile/employee-profile.service';
import { MatExpansionPanel } from '@angular/material/expansion';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { AddProposalService } from '../proposals/add-proposal/add-proposal.service';
import { CompetenciesService } from '../competencies/competencies.service';
import { ChangeDetectorRef } from '@angular/core';
import { SharedSkillService } from '../skill-repository/shared-skill.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { TemplateUploadModalComponent } from '../template-upload-modal/template-upload-modal.component';
import { DeleteDialogComponent } from 'src/app/components/delete-dialog/delete-dialog.component';
import { AuthServiceService } from 'src/app/services/auth-service.service';
import { GsdRoles } from 'src/app/enums/gsdRoles.enum';
import { ConfirmationBackDialogComponent } from 'src/app/components/confirmation-back-dialog/confirmation-back-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ViewfileComponent } from 'src/app/components/viewfile/viewfile.component';
import { AddDialogComponent } from 'src/app/components/add-dialog/add-dialog.component';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { ConfirmationPopupComponent } from './ConfirmationPopup.component';
import { MatTooltip } from '@angular/material/tooltip';
import { MatExpansionModule } from '@angular/material/expansion';
import { Pipe, PipeTransform } from '@angular/core';
import { auto } from '@popperjs/core';
import { CommentsDialogComponent } from 'src/app/components/comments-dialog/comments-dialog.component';

@Pipe({ name: 'tooltipList' })
export class TooltipListPipe implements PipeTransform {

  transform(lines: string[]): string {

    let list: string = '';

    lines.forEach(line => {
      list += line + '\n';
    });

    return list;
  }
}
@Component({
  selector: "app-employee-details",
  templateUrl: "./employee-details.component.html",
  styleUrls: ["./employee-details.component.css"],
})

export class EmployeeDetailsComponent implements OnInit {
  @Input() selectedEmployeeId: any;
  @Output() viewEmployees = new EventEmitter<any>();
  @ViewChild('exposureInput') exposureInput!: ElementRef;
  @ViewChild('projectInput') projectInput!: ElementRef;
  @ViewChild('tabgroup', { static: false }) tabgroup: MatTabGroup;
  @ViewChild('commentsExpansionPanel') commentsExpansionPanel: MatExpansionPanel;
  @ViewChild('tooltipTrigger') tooltipTrigger: ElementRef;
  @ViewChild(MatTooltip) tooltip: MatTooltip;
  todayDate = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
  employee: any = {};
  backUpEmployee: any = {};
  empId: number;
  isEmployeeEditable: boolean;
  role: string;
  adminRole: number;
  CompSubCompRole: boolean;
  isUserEditable: boolean;
  domainsList: any;
  screenMode: boolean;
  isViewScreen: boolean;
  isEditScreen: boolean;
  isEmployeeSearch: boolean = false;
  isSavebuttonvisible: boolean = false;
  isemployeesearchhide:boolean=true;
  loading: boolean;
  compname: string;
  selectedCompetency: any;
  selectedCompetencyIndex = 0;
  prevCompetencyIndex = 0;
  subCompetency: any;
  serviceAreasInfo: any[];
  isViewMode: boolean;
  filteredOptions: any[];
  primarySkills: { [key: string]: any } = [];
  secondarySkills: any[];
  certificateTypes: any[];
  certificateAllTypes: any[];
  filteredCertificateTypes: any[];
  isPrimary: boolean;
  inputComments: string;
  commentsError: string;
  accordionCompetancy: any;
  accordionSubCompetancy: any;
  clickedApprovedOrRejected: boolean = false;
  approvedData: boolean = false;
  rejectedData: boolean = false;
  isTemplateDownloaded = false;
  isAreasNotFilled = false;
  filteredValues: any[];
  certificateServiceAreas: any[];
  previousTabIndex: number = 0;
  selectedTabIndex: number = 0;
  loginemployeeId:number;
  statusDescriptions: any = ["You have received training and gained practical experience by working on 1-2 projects, or you have relevant project experience of 6 months.",
    "You have actively participated in and contributed to 3-6 projects, or you possess relevant project experience ranging from 6 months to 3 years.",
    "You have extensively worked on more than 6+ projects,showcasing your expertise and a deep understanding of the service line. Additionally, you possess significant project experience of 3 years or more, demonstrating your ability to consistently deliver successful outcomes in various projects."];
  statusTitle: any = ["Beginner", "Intermediate", "Expert"]
  uncompetencyEmployee = false;
  @ViewChildren(MatExpansionPanel, { read: ElementRef }) panelElements: QueryList<ElementRef>;
  @ViewChildren(MatExpansionPanel) panels: QueryList<MatExpansionPanel>;
  isUploadBtnVisible:boolean = false;

  public expertiseIcons: any = [
    {
      text: 'account_balance',
      icon: 'account_balance'
    },
    {
      text: 'spa',
      icon: 'spa'
    },
    {
      text: 'partner_exchange',
      icon: 'partner_exchange',
    },
    {
      text: 'beach_access',
      icon: 'beach_access',
    },
    {
      text: 'shopping_cart',
      icon: 'shopping_cart',
    },
    {
      text: 'factory',
      icon: 'factory',
    },
    {
      text: 'wind_power',
      icon: 'wind_power',
    },
    {
      text: 'warehouse',
      icon: 'warehouse',
    },
    {
      text: 'conveyor_belt',
      icon: 'conveyor_belt',
    },
    {
      text: 'media_output',
      icon: 'media_output',
    },
  ];
  filteredprimaryskillsItems: any;
  filteredSecondaryskills: any;
  filtercertificateType: any = [];
  allSkills: any[];
  currentEmployee: string = "";

  constructor(
    private employeeService: EmployeeService,
    private toastr: ToastrService,
    public dialog: MatDialog,
    public proposalService: AddProposalService,
    public competencyService: CompetenciesService,
    public cd: ChangeDetectorRef,
    public sharedSkillService: SharedSkillService,
    public router: Router,
    public datepipe: DatePipe,
    private _location: Location,
    private auth: AuthServiceService,
    private activeRoute: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private renderer: Renderer2
  ) {
  }
  templates: any
  templatesArray: any = []
  ngOnInit() {
    this.loginemployeeId = parseInt(localStorage.getItem('Id'));
    this.activeRoute.queryParams.subscribe(params => {
      this.selectedTabIndex = +params['selectedIndex'] || 0;
    });
    this.competencyService.competencyName$.subscribe((value) => {
      this.compname = value;
    });
    this.activeRoute.params.subscribe((params) => {
      
      this.empId = params["EmployeeId"];
    });
      if(this.empId != this.loginemployeeId)
      {
        this.isemployeesearchhide= false;
      }
      else{
        this.isSavebuttonvisible=true;
      }
  

    this.isEmployeeEditable = this.sharedSkillService.getIsEditable();
    this.role = this.auth.getRole();
    if (this.role.includes(GsdRoles.SuperAdmin)) {
      this.adminRole = 0;
      this.isEmployeeEditable = true;
    }
    else if (this.role.includes(GsdRoles.Admin)) {
      this.adminRole = 0;
      this.isEmployeeEditable = true;
    }
    else if (this.role.includes(GsdRoles.Leadership)) {
      this.adminRole = 0;
      this.isEmployeeEditable = false;

    }
    else if (this.role.includes(GsdRoles.CompetencyLeader || GsdRoles.SubCompetencyLeader)) {
      this.CompSubCompRole = true;
      this.isEmployeeEditable = true;
      this.adminRole = 2;
    }
    else {
      this.adminRole = 2;
    }
    if (this.role.includes(GsdRoles.SkillUser)) {
      this.isUserEditable = true;
    }
    this.getEmployeeDetalis(this.empId);
    this.proposalService.getDomains().subscribe(res => {
      this.domainsList = res.data.items
      this.domainsList.forEach((domain, index) => {
        if (index < this.expertiseIcons.length) {
          domain['icon'] = this.expertiseIcons[index].icon;
        }
      })
      this.cd.detectChanges()
    })
    this.screenMode = this.sharedSkillService.getMode();
    if (this.screenMode) {
      this.isViewScreen = true;
    }
    else {
      this.isEditScreen = true;
    }
  }
  getExperience(value) {
    let expYears = Math.floor(value);
    let expMonths = Math.round((value - expYears) * 12);
    let yearsString = expYears > 0 ? expYears + " Year(s)" : "";
    let monthsString = expMonths > 0 ? expMonths + " Month(s)" : "";
    return (yearsString + " " + monthsString).trim();
  }
  onResumeUpload(data): void {
    const files = Array.from(data.target.files);

    files.forEach(async (element: File) => {
      const allowedFileTypes = ['.doc', '.docx'];
      const fileExtension = element.name.substring(element.name.lastIndexOf('.')).toLowerCase();
      const isValidSize = element.size < 2000000;
      if (allowedFileTypes.includes(fileExtension) && isValidSize == true) {
        const processedFile = await this.convertFile(element);
        const isValidSize = element.size < 2000000; // 2 MB limit, you can adjust this as needed
        if (isValidSize == false) {
          this.toastr.error('Filesize is More than 2MB');
          return;
        }
        this.employee.resume = {
          name: element.name,
          fileExtention: fileExtension,
          mimeType: element.type,
          fileBase64: processedFile.toString().split(",")[1],
          sharePointUrl: "",
          sharepointId: null,
          isValidSize: isValidSize
        };
        this.isUploadBtnVisible = true;


      } else {
        this.isUploadBtnVisible = false;

        if (allowedFileTypes.includes(fileExtension))
          this.toastr.error('Filesize should not be more than 2MB');
        else
          this.toastr.error('Only DOC, and DOCX files are allowed');
      }
    });
  }

  uploadResume(): void {
    this.employeeService.draftEmployee(this.employee).subscribe(res => {
      this.toastr.success("Resume uploaded successfully");
      this.isUploadBtnVisible = false;
      this.getEmployeeDetalis(this.empId);
    }, error => {
      this.loading = false;
      this.toastr.error("Something went wrong, Please try again.");
    })
    
  }
  
  
  updateResume(data): void {
    this.onResumeUpload(data); // Reuse the upload logic
  }
  
  deleteResume(): void {
    const dialogRef = this.dialog.open(DeleteDialogComponent, {
      width: 'auto',
      minWidth: '550px',
      height: 'auto',
      data: {
        name: 'Resume',
        title: 'Delete Resume'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.employee.resume = null;
        this.employeeService.draftEmployee(this.employee).subscribe(res => {
        }, error => {
          this.loading = false;
          this.toastr.error("Something went wrong, Please try again.");
        })
        this.employee.resume = null;
          this.isUploadBtnVisible = false;
          this.toastr.success('Resume deleted successfully');
      }
    });
  }
  getEmployeeDetalis(empId?: number) {
    if (empId) {
      this.loading = true;
      this.employeeService.getEmployeeDetails(empId).subscribe(res => {
        this.employee = res.data;
        this.uncompetencyEmployee = false;
        this.employee.exp = this.getExperience(this.employee.experience);
        let intialCompetency = this.employee?.competencies?.find(c => c.isDefault);

          if (intialCompetency?.subCompetencies?.length > 0) {
            this.subCompetency = intialCompetency.subCompetencies.find(
              (s) => s.isDefault
            );
            this.subCompetency.primarySkills =
              this.subCompetency.primarySkills ?? [];
            this.subCompetency.secondarySkills =
              this.subCompetency.secondarySkills ?? [];
            this.subCompetency.isSelected = true;
            this.subCompetency.isExpanded = true;
          } else if (!intialCompetency) {
            this.uncompetencyEmployee = true;
          }
          this.employee?.competencies?.forEach((c) => {
            c.subCompetencies.forEach((s) => {
              s.primarySkills?.forEach((p) => {
                p.competencyId = c.competencyId;
                p.subcompetencyId = s.subCompetencyId;
                if (p.experience) {
                  this.convertExperience(p);
                }
              });
              s.secondarySkills?.forEach((s) => {
                if (s.experience) {
                  this.convertExperience(s);
                }
              });
              s.certificates?.forEach((c) => {
                if (c.expiryDate) {
                  c.expiryDate = this.convertDate(c.expiryDate);
                }
                c.isExpired = c.expiryDate < this.todayDate ? true : false;
                if (c.completedDate) {
                  c.completedDate = this.convertDate(c.completedDate);
                }
                if (c.plannedDate) {
                  c.plannedDate = this.convertDate(c.plannedDate);
                }
                c.serviceAreaId = c.serviceAreaId ?? 0;
              });
            });
          });
          this.loading = false;
          this.cd.detectChanges();
          this.backUpEmployee = JSON.parse(JSON.stringify(this.employee));
          this.getPrimarySkills(
            this.accordionCompetancy,
            this.accordionSubCompetancy,
            ""
          );
          this.subCompetency.showSecondarySkillBtn =
            this.subCompetency.primarySkills.length > 0 ? true : false;
          this.getSecondarySkills("");
          this.getCertificationTypes("");
        },
        (error) => {
          this.loading = false;
        }
      );
    }
  }
  getDomainValue(domain: { name: any }) {
    if (this.employee.domains)
      return this.employee.domains
        .map((x) => x.trim())
        .indexOf(domain.name.trim()) > -1
        ? true
        : false;
    return false;
  }

  openResume() {
    window.open(
      "https://acsicorp-my.sharepoint.com/personal/dharmateja_chennuri_innovasolutions_com/_layouts/15/onedrive.aspx?id=%2Fpersonal%2Fdharmateja%5Fchennuri%5Finnovasolutions%5Fcom%2FDocuments%2FResume&ct=1707215729280&or=Teams%2DHL&ga=1&LOF=1"
    );
  }
  domainChange(event: { checked: any }, domain: { name: any }) {
    if (event.checked) {
      if (!this.employee.domains) this.employee.domains = [];
      this.employee.domains.push(domain.name);
    } else {
      this.employee.domains = this.employee.domains.filter(
        (dm) => dm != domain.name
      );
    }

    this.employee.domains = Object.assign([], this.employee.domains);
    this.cd.detectChanges();
  }
  convertFile(file: Blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }
  backButton() {
    if (this.adminRole == 0) {
      this._location.back();
    }
    else {
      this.router.navigate([`Competencies/${this.compname}`])
    }
  }
  removeResume() {
    const dialogRef = this.dialog.open(DeleteDialogComponent, {
      width: auto,
      minWidth: '550px',
      height: auto,
      data: {
        name: 'Resume',
        title: "Delete Resume"
      }
    })
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.employee.resume = null;
      }
    });
  }
  onCompetencyChange(event: MatTabChangeEvent, onSubmit = false) {
    if (!this.isEmployeeSearch) {
      if (onSubmit || this.tabgroup.selectedIndex != this.prevCompetencyIndex && this.validateSubCompetency(this.subCompetency)) {
        this.tabgroup.selectedIndex = this.prevCompetencyIndex;
      } else {
        this.prevCompetencyIndex = event.index;
        this.employee?.competencies.map(c => c.isSelected = false);
        this.selectedCompetency = this.employee?.competencies[event.index];
        this.selectedCompetency.isSelected = true;
        let selectedSubCompetency = this.selectedCompetency.subCompetencies.find(s => s.isSelected);
        if (selectedSubCompetency) {
          this.subCompetency = selectedSubCompetency;
        }
        else {
          this.selectedCompetency.subCompetencies[0].isSelected = true;
          this.subCompetency = this.selectedCompetency.subCompetencies[0];
        }

      }
      // this.getPrimarySkills(this.selectedCompetency.competencyId, this.subCompetency.subCompetencyId, '');
      this.getPrimarySkills(this.accordionCompetancy, this.accordionSubCompetancy, '');

      this.getSecondarySkills('');
      this.getServiceAreas(this.selectedCompetency.competencyId);

    }
    else {
      this.isEmployeeSearch = false;
    }


  }
  openAddCompetencyDialog() {
    const dialogRef = this.dialog.open(AddDialogComponent, {
      width: '570px',
      panelClass: 'view-file',
      data: {
        title: "isDefault", data: {
          competencies: this.employee.competencies ?? [],
        }
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.employee.competencies.forEach(c => {
        if (c.subCompetencies && c.subCompetencies.length > 0) {
          this.getServiceAreasInfo(c.competencyId, c.subCompetencies)
        }
      })
    });

  }
  removeCompetency(competency, competencies) {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      data: {
        message: "Do you want to remove Competency?"
      },
    });
    const res = dialogRef.afterClosed().subscribe((result) => {
      if (result == "success") {
        const index = competencies.findIndex(s => s.competencyId == competency.competencyId);
        if (index > -1) {
          this.selectSubCompetencyOnRemove(index);
          competencies.splice(index, 1);
        }
      }
    });
  }
  removeSubCompetency(subCompetency, subCometencies, competency) {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      data: {
        message: "Do you want to remove sub competency?"
      },
    });
    const res = dialogRef.afterClosed().subscribe((result) => {
      if (result == "success") {
        const index = subCometencies.findIndex(s => s.subCompetencyId == subCompetency.subCompetencyId);
        if (index > -1) {
          if (subCometencies[index].isSelected) {
            if (subCometencies[index - 1]) {
              subCometencies[index - 1].isSelected = true;
            }
            else if (subCometencies[index + 1]) {
              subCometencies[index + 1].isSelected = true;
            }
          }
          subCometencies.splice(index, 1);
        }
        let newsubCompetency = subCometencies.find(s => s.isSelected);
        if (newsubCompetency) {
          this.subCompetency = newsubCompetency;
        }
        else if (subCometencies.length == 0) {
          let competencyIndex = this.employee.competencies.findIndex(c => c.competencyId == competency.competencyId);
          if (this.employee.competencies.length > 1 && competencyIndex > -1) {
            this.selectSubCompetencyOnRemove(competencyIndex);
            this.employee.competencies.splice(competencyIndex, 1);
          }
        }
      }
    });
  }
  selectSubCompetencyOnRemove(competencyIndex: number) {
    let selectedSubCompetency = this.employee.competencies[competencyIndex - 1].subCompetencies.find(s => s.isSelected);
    if (selectedSubCompetency) {
      this.subCompetency = selectedSubCompetency;
    }
    else {
      this.subCompetency = this.employee.competencies[competencyIndex - 1].subCompetencies[0];
      this.subCompetency.isSelected = true;
    }
  }
  onSubCompetencyChange(subCompetency, subCompetencies, onSubmit = false) {
    if (subCompetency.subCompetencyId != this.subCompetency.subCompetencyId && !this.validateSubCompetency(this.subCompetency)) {
      subCompetencies.forEach(s => {
        if (s.subCompetencyId == subCompetency.subCompetencyId) {
          s.isSelected = true;
        }
        else {
          s.isSelected = false
        }
      });
      this.subCompetency = subCompetency;
      if (!onSubmit) {
        // this.getPrimarySkills(this.selectedCompetency.competencyId, this.subCompetency.subCompetencyId, '');
        this.getPrimarySkills(this.accordionCompetancy, this.accordionSubCompetancy, '');

        this.getSecondarySkills('');
        this.subCompetency.areaPanelState = false;
      }
    }
  }

  AccordionExpand(subCompetency, competency) {
    var openedPanelId = 'panel_Comp_' + this.employee.openedCompetency?.competencyId + '_subComp_' + this.employee.openedSubCompetency?.subCompetencyId;
    var TobeOpenPanelId = 'panel_Comp_' + competency?.competencyId + '_subComp_' + subCompetency?.subCompetencyId;
    const panelElements = this.panelElements.toArray();

    this.accordionCompetancy = competency.competencyId;
    this.accordionSubCompetancy = subCompetency.subCompetencyId;
    this.getServiceAreasInfo(competency.competencyId, competency.subCompetencies);

    if (this.employee.isCompetencyExpanded && this.employee.openedSubCompetency !== subCompetency) {
      if (!this.validateSubCompetency(this.employee.openedSubCompetency)) {
        this.selectedTabIndex = 0;
        this.previousTabIndex = 0;
        this.employee.openedSubCompetency.isExpanded = false;
        subCompetency.isExpanded = true;
        this.employee.isCompetencyExpanded = true;
        this.employee.openedSubCompetency = subCompetency;
        this.employee.openedCompetency = competency;
        this.subCompetency = subCompetency
      }
      else {
        this.panels.forEach((panel, index) => {
          const panelId = panelElements[index].nativeElement.id;
          if (openedPanelId == panelId) {
            panel.open();
          }
          if (TobeOpenPanelId == panelId) {
            panel.close();
          }
        });
      }
    }
    else {
      this.employee.isCompetencyExpanded = true;
      this.employee.openedSubCompetency = subCompetency;
      this.employee.openedCompetency = competency;
      this.subCompetency = subCompetency;
    }
  }


  AccordionClose(comp, subcomp): boolean {
    return this.accordionCompetancy !== comp && this.accordionSubCompetancy !== subcomp;
  }
  getServiceAreaInfo(area) {
    let _serviceInfo = area ? area : ''
    return _serviceInfo.replaceAll(/<p>/g, '<p class="tooltipData mb-0">');
  }
  updatedServiceArea(event: { value: any; }, areaIndex: any, name: any, serviceArea: any, areas) {
    areas = areas.map((ca: { proficiency: any; serviceArea: any; name: any; }, i: any) => {
      if (areaIndex == i) {
        ca.proficiency = Number(event.value);
        ca.serviceArea = name ? name : serviceArea;
      }
      if (!ca.serviceArea && ca.name) ca.serviceArea = ca.name;
      return { ...ca };
    });
  }
  updateExposureCountValidation(key: string, object: { [x: string]: any; }) {

    if (!object.exposureCount || (object.exposureCount < 0 || object.exposureCount >= 99 || object.exposureCount % 1 !== 0)) {
      object[key] = true;
      this.toastr.error("Entered exposure Count is invalid for areas");
      return;
    } else {
      if (object[key]) {
        delete object[key];
      }
    }
  }
  updateProjectCountValidation(key: string, object: { [x: string]: any; }) {
    if (!object.projectCount || (object.projectCount < 0 || object.projectCount >= 99 || object.projectCount % 1 !== 0)) {
      object[key] = true;
      return;
    } else {
      // if (object.editingField !== 'projectCount') {
      //   object.exposureCount = null;
      //   object.isInvalidExposureRange = false
      // }
      if (object[key]) {
        delete object[key];
      }
    }
  }
  cancelEdit() {
    if (this.isViewMode) {
      this._location.back();
    }
    else {

      const dialogRef = this.dialog.open(ConfirmationBackDialogComponent, {
        width: '550px',
        height: auto,
        data: { Title: "Warning!", Content: "You have unsaved data. Do you want to continue?" }
      })
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          if (this.adminRole == 2 && !this.CompSubCompRole)
            this.router.navigate(['Home/Profile-view'])
          else
            this._location.back();
        }
      });
    }

  }
  updateExperienceYearsValidation(key: string, object: { [x: string]: any; }, state) {
    const combinedExperience = object.experienceYears + object.experienceMonths / 10;

    const invalidExperienceMessage = (state == 3 ?
      'Entered experience is invalid for the Secondary skill.' :
      state == 2 ? 'Entered experience is invalid for the Primary skill.' :
        'Entered experience is invalid for the specified area.');

    if ((combinedExperience !== "" || combinedExperience === 0) && (combinedExperience <= 0 || combinedExperience >= 99) && object.experienceYears < 0) {
      object[key] = true;
      this.toastr.error(invalidExperienceMessage);
    } else if (object.experienceYears < 0 || object.experienceYears >= 100) {
      object[key] = true;
      this.toastr.error(state == 3 ?
        'Entered year value is invalid for the Secondary skill.' :
        state == 2 ? 'Entered year value is invalid for the Primary skill.' :
          'Entered year value is invalid for the specified area.');
    } else {
      delete object[key];
    }
    this.calculateCombinedExperience(object);

  }

  updateExperienceMonthsValidation(key: string, object: { [x: string]: any }, state) {
    const combinedExperience = object.experienceYears + object.experienceMonths / 10;

    const invalidExperienceMessage = (state == 3 ?
      'Entered experience  is invalid for the Secondary skill.' :
      state == 2 ? 'Entered experience  is invalid for the Primary skill.' :
        'Entered experience is invalid for the specified area.');

    if (
      (combinedExperience !== "" || combinedExperience === 0) &&
      (combinedExperience <= 0 || combinedExperience >= 99) && object.experienceMonths < 0
    ) {
      object[key] = true;
      this.toastr.error(invalidExperienceMessage);
    } else if (object.experienceMonths < 0 || object.experienceMonths > 11) {
      object[key] = true;
      this.toastr.error(state == 3 ?
        'Entered month value is invalid for the Secondary skill.' :
        state == 2 ? 'Entered month value is invalid for the Primary skill.' :
          'Entered month value is invalid for the specified area.');
      return;
    } else if (object[key]) {
      delete object[key];
    }

    this.calculateCombinedExperience(object);
  }
  calculateCombinedExperience(area: { [x: string]: any; }) {
    const years = area.experienceYears || 0;
    const months = area.experienceMonths || 0;
    const combinedExperience = years + months / 12;

    area.experience = combinedExperience;

  }

  convertExperience(data: any) {
    let years = Math.floor(data.experience);
    let months = Math.round((data.experience - years) * 12);
    data.experienceYears = years;
    data.experienceMonths = months;
  }

  addSkill(skills, isPrimary) {
    this.getPrimarySkills(this.accordionCompetancy, this.accordionSubCompetancy, "");
    this.getSecondarySkills("");
    var skilltype = isPrimary ? "primary" : "secondary";
    const currentSkills = skills;
    const isSkillListValid = this.validateSkills(currentSkills, skilltype);
    if (!isSkillListValid) {
      return; 
    }
    if (isSkillListValid) {
      currentSkills.push({
        skill: "",
        experience: 0,
        experienceYears: null,
        experienceMonths: null,
        proficiency: 0,
        isCertified: false,
        isInvalidExperienceRange: false,
        competencyId: this.accordionCompetancy,
        subcompetencyId: this.accordionSubCompetancy,
        CreatedDate: new Date().toISOString()
      });
    }    
    if (this.subCompetency.primarySkills.length > 0) {
      this.subCompetency.showSecondarySkillBtn = true;
      this.cdr.detectChanges();
    }
  }
  onBlurValidateSkill(skill, type) {
    setTimeout(() => {
      if (skill.selectionMade) {
        skill.selectionMade = false; // Reset so future blurs validate as normal
        return;
      }
  
      if (skill.skill) {
        
        skill.isInvalidSkill = this.checkvalidskill(skill, type);
        if (skill.isInvalidSkill) {
          if (this.toastr.currentlyActive < 1) {
            this.toastr.error('Please Select a Valid Skill from Dropdown');
          }
        }
      }
    }, 300); // Small delay gives Angular time to update the model from dropdown
  }
  
  onSkillSelected(skillObj, selectedSkill) {
    skillObj.skill = selectedSkill;
    skillObj.isInvalidSkill = false;
    skillObj.alreadySelectedSkill = false;
    skillObj.selectionMade = true;
  }

  checkvalidskill(skill, type) {
    if (this.selectedTabIndex != 0) {
      // if (type == "primary") {
      //   return this.primarySkills[
      //     "comp" +
      //     this.accordionCompetancy +
      //     "subComp" +
      //     this.subCompetency.subCompetencyId
      //   ].find((x) =>
      //     x.name === skill.skill &&
      //     x.competencyId === skill.competencyId &&
      //     x.subCompetencyId === skill.subcompetencyId
      //   ) ? false : true;
      // } else {
        return this.secondarySkills.find((x) =>
          x.name.toLowerCase() == skill.skill.toLowerCase()
        ) ? false : true;
      //}
    }
  }

  validateSkills(Skills, skilltype): boolean {
    let isValidSkill = true;
    let hasInvalidExperiennce = false;
    let hasInValidSkill = false;
    let hasMissingMandatoryFields = false;
    Skills.forEach((s) => {
      s.isInvalidSkill = this.checkvalidskill(s, skilltype);
      s.isInvalidProficiency = s.proficiency ? false : true;
      s.isInvalidExpYears = s.experienceYears >= 0 ? false : true;
      s.isInvalidExpMonths = s.experienceMonths >= 0 ? false : true;
      let combinedExperience = s.experienceYears + s.experienceMonths / 10;
      if (
        (combinedExperience !== "" || combinedExperience === 0) &&
        (combinedExperience <= 0 || combinedExperience >= 99)
      ) {
        s.isInvalidExperienceRange = true;
        hasInvalidExperiennce = true;
      }
      if (s.skill === "") {
        hasMissingMandatoryFields = true;
      }
      else if (s.isInvalidSkill) {
        hasInValidSkill = true;
      }
      if (s.isInvalidProficiency || s.isInvalidExpYears == undefined || s.isInvalidExpMonths == undefined) {
        hasMissingMandatoryFields = true;
      }
    });
    let duplicates = Skills.filter(
      (item, index, self) =>
        index !== self.findIndex((t) => t.skill === item.skill)
    );

    if (duplicates.length > 0) {
      duplicates[0].alreadySelectedSkill = true;
      isValidSkill = false;
      this.toastr.error(`Please remove duplicate skills`);
    }
    else if (hasMissingMandatoryFields) {
      this.toastr.error(`Please fill in all mandatory fields.`);
      isValidSkill = false;
    } 
    else if (hasInValidSkill) {
      if(this.toastr.currentlyActive < 1){
        this.toastr.error(`Please Select a Valid Skill from Dropdown`);
      }     
      isValidSkill = false;
    }
    else if (hasInvalidExperiennce) {
      this.toastr.error(`Please select a valid Experience.`);
      isValidSkill = false;
    }
    return isValidSkill;
  }
  validateAreas(serviceAreas): boolean {
    let validAreas = true;
    let hasMissingMandatoryFields = false;
    let hasInvalidExperience = false;
    let hasInvalidProjectCount = false;
    let hasInvalidExposureCount = false;
    if (serviceAreas && serviceAreas?.length > 0) {
      if (serviceAreas.find((s) => s.proficiency != 4)) {
        serviceAreas.forEach((s) => {
          if (s.proficiency != 4) {

            s.isInvalidProjectRange = s.projectCount != null ? false : true;
            s.isInvalidExpYears = s.experienceYears >= 0 ? false : true;
            s.isInvalidExpMonths = s.experienceMonths >= 0 ? false : true;
            let combinedExperience = s.experienceYears + s.experienceMonths / 10;

            if (!s.projectCount) {
              s.isInvalidProjectRange = true;
            }
            if (s.projectCount <= 0 || s.projectCount >= 99) {
              hasInvalidProjectCount = true;
            }
            if (s.isInvalidExpYears || s.isInvalidExpMonths || (
              (combinedExperience !== "" || combinedExperience === 0) &&
              (combinedExperience <= 0 || combinedExperience >= 99)
            )) {
              s.isInvalidExperienceRange = true;
              hasInvalidExperience = true;
            }
            if (s.exposureCount !== undefined) {
              if (s.exposureCount < 0) {
                hasInvalidExposureCount = true;
              }
            }
            if (s.projectCount == null || s.isInvalidExpYears == undefined || s.isInvalidExpMonths == undefined) {
              hasMissingMandatoryFields = true;
            }
          }
        });
        if (hasMissingMandatoryFields) {
          this.toastr.error("Please fill all the Mandatory Fields");
          validAreas = false;
        }
        else if (hasInvalidExperience && hasInvalidProjectCount && hasInvalidExposureCount) {
          this.toastr.error("Please select valid Experience");
          this.toastr.error("Please select valid project Count");
          this.toastr.error("Please select valid Exposure Count");
          validAreas = false;
        }
        else if (hasInvalidExposureCount) {
          this.toastr.error("Please select valid Exposure Count");
          validAreas = false;
        }
        else if (hasInvalidProjectCount) {
          this.toastr.error("Please select valid project Count");
          validAreas = false;
        }
        else if (hasInvalidExperience) {
          this.toastr.error("Please select valid Experience");
          validAreas = false;
        }
        
      } else {
        validAreas = false;
        this.toastr.error("Please select at least one Area of Expertise.");
      }
    }
    return validAreas;
  }
  getPrimarySkills(competencyId, SubCompetencyId, search) {
    this.employeeService
      .getAllPrimarySkills(competencyId, [SubCompetencyId], search)
      .subscribe((result) => {
        var key = "comp" + competencyId + "subComp" + SubCompetencyId;
        let skills = result.data;
        let selectedServiceLines = this.subCompetency.serviceAreas.filter(s => s.proficiency == 1 || s.proficiency == 2 || s.proficiency == 3);
        if (skills && selectedServiceLines && skills.length > 0) {
          skills = skills.filter(s => s.serviceLineId == 0 || selectedServiceLines.some(sl => sl.id === s.serviceLineId));
          this.primarySkills[key] = skills;
          this.filteredprimaryskillsItems = result.data.slice();

        }
        else {
          this.primarySkills[key] = skills;
          this.filteredprimaryskillsItems = result.data.slice();

        }
      });
  }
  getSecondarySkills(search) {
    this.employeeService
      .getAllSecondarySkills(0, 0, search)
      .subscribe((result) => {
        const distinctSecondarySkills = result.data.reduce((acc, curr) => {
          if (!acc.map((i) => i.name.trim("")).includes(curr.name.trim(""))) {
            acc.push(curr);
          }
          return acc;
        }, []);
        this.secondarySkills = distinctSecondarySkills?.filter(s => s.serviceLineId == 0);
        this.filteredSecondaryskills = distinctSecondarySkills?.filter(s => s.serviceLineId == 0);
      });
  }
  getCertificationTypes(search) {
    this.employeeService.getCertificationTypes(search).subscribe((res) => {
      this.certificateTypes = res.data;
      this.certificateAllTypes = this.certificateTypes;
    })
  }

  searchCertificationtype(search) {
    this.filtercertificateType = this.certificateTypes.filter((x) =>
      x.name.toLowerCase().includes(search.toLowerCase())
    );
    const selectedType = this.filtercertificateType.find(t => t.name === search);
  }
  
  getlevel(name: string):any{
    let index = this.filtercertificateType.findIndex(t => t.name === name);
    var val = this.filtercertificateType[index];
    var id;

    switch (val?.level) {
      case 'Beginner':
        id = 1;
        break;
      case 'Intermediate':
        id = 2;
        break;
      case 'Expert':
        id = 3;
        break;
    }

    return id;
  }
  expiryyr(name: string, dt: Date): any {
    let index = this.filtercertificateType.findIndex(t => t.name === name);
    var val = this.filtercertificateType[index];
    var yrs = val?.expiryYears==0 ? 100: val?.expiryYears;
    const newDate = new Date(dt);
    const formattedDate = new Date(newDate.setFullYear(newDate.getFullYear() + yrs));

    const year = formattedDate.getFullYear();
    const month = String(formattedDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(formattedDate.getDate()).padStart(2, '0');
    
    return `${year}-${month}-${day}`;
  }
  
  filterSkills(skills: any[], allSkills: any[]) {
    allSkills.forEach((p) => {
      let index = skills.findIndex((ps) => ps.name == p.skill);
      if (index > -1) {
        skills.splice(index, 1);
      }
    });
  }
  filterCertifications(certifications: any[], allCertifications: any[]) {
    allCertifications.forEach((p) => {
      let index = certifications.findIndex((ps) => ps == p.name);
      if (index > -1) {
        certifications.splice(index, 1);
      }
    });
  }
  searchSecSkill(event: any) {
    this.filteredSecondaryskills = this.secondarySkills.filter((item) =>
      item.name.toLowerCase().includes(event.toLowerCase())
    );
    //this.getSecondarySkills(event);
  }
  searchPriSkill(event: any) {
    this.filteredprimaryskillsItems = this.primarySkills[
      "comp" +
      this.accordionCompetancy +
      "subComp" +
      this.subCompetency.subCompetencyId
    ].filter((item) => item.name.toLowerCase().includes(event.toLowerCase()));

    // this.getPrimarySkills(this.selectedCompetency.competencyId, this.subCompetency.subCompetencyId, event);
    // this.getPrimarySkills(this.accordionCompetancy, this.accordionSubCompetancy, event);
  }
  addCertification(certifications, status) {
    if (this.validateCertification(certifications)) {
      certifications.push({
        copyFileName: "",
        hasAttachment: false,
        status: status,
        serviceAreaId: 0,
        CreatedOn: new Date().toISOString()
      });
    }
  }

  checkvalidCertificate(name) {
    if (this.selectedTabIndex != 0) {
      return this.certificateTypes.find((x) => x.name === name) ? false : true;
    }
  }

  validateCertification(certifications): boolean {
    let isValid = true;
    let hasInvalidType = false;
    let hasMissingMandatoryFields = false;
    let hasAttachment = false;
    let hasDuplicates = false;
    let hasMissingCertification = false;
    let dateCheck = false;
    certifications?.forEach((c) => {
      if (c.status == 1) {
        c.isInvalidCertificateLevel = c.certificateLevel ? false : true;
        c.isInvalidType = this.checkvalidCertificate(c.type?.trim());
        c.isInvalidPlannedDate = c.plannedDate ? false : true;
        c.serviceAreaId = c.serviceAreaId || 0;
        if (
          c.isInvalidPlannedDate) {
          hasMissingMandatoryFields = true;
          dateCheck = true;
        }
        if (c.type == "" || c.type == undefined) {
          hasMissingCertification = true;
        }
        else if (c.isInvalidType) {
          hasInvalidType = true;
        }
      }
      else if (c.status == 3) {
        c.isInvalidType = this.checkvalidCertificate(c.type?.trim());
        c.isInvalidCompletedDate = c.completedDate ? false : true;
        c.serviceAreaId = c.serviceAreaId || 0;

        if (
          c.isInvalidCompletedDate) {
          hasMissingMandatoryFields = true;
          dateCheck = true;
        }
        if (c.type == "" || c.type == undefined) {
          hasMissingCertification = true;
        }
        else if (c.isInvalidType) {
          hasInvalidType = true;
        }
      }
      let singletypeCertifications = certifications?.filter(
        (cert) => {if(cert.status == c.status){
          if(c.status != 1){
            return cert.expiryDate >= this.todayDate;
          }
          return true;
        }

      }
      );
      let duplicates = singletypeCertifications.filter(
        (item, index, self) =>
          index !== self.findIndex((t) => t.type === item.type )
      );
      if (duplicates?.length > 0) {
        duplicates[0].alreadySelectedType = true;
        hasDuplicates = true;
      }
      else if (
        c.status == 3 &&
        certifications
          ?.filter((c) => c.status == 3)
          ?.find(
            (s) =>
              !s.certificateAttachment || s.certificateAttachment?.length == 0
          )
      ) {
        hasAttachment = true;
      }
    });


    if (hasDuplicates) {
      isValid = false;
      this.toastr.error("Please remove duplicate types.");
    }
     else if (hasMissingMandatoryFields ) {
      this.toastr.error("Please fill in all mandatory fields");
      isValid = false;
    }
    else if (hasMissingMandatoryFields && dateCheck ) {
      this.toastr.error("Please fill in all mandatory fields");
      isValid = false;
    }
    else if (hasInvalidType) {
      this.toastr.error("Please select a Valid Certificate Name from Dropdown");
      isValid = false;
    }
    else if(hasMissingCertification) {
      this.toastr.error("Please select a Valid Certificate Name from Dropdown");
      isValid = false;
    }
    else if (hasAttachment) {
      this.toastr.error("Please upload certificate documents.");
      isValid = false;
    }
    return isValid;
  }
  deletePrimarySkill(index: number,primarySkills,priSkill: any ) {
    const skillName = priSkill?.skill ? `${priSkill.skill} - Primary Skill` : 'Primary Skill';
    const skillTitle = priSkill?.skill ? `Delete Secondary Skill: ${priSkill.skill}` : 'Delete Primary Skill';

    const dialogRef = this.dialog.open(DeleteDialogComponent, {
      width: auto,
      minWidth: '550px',
      height: auto,
      data: {
        name: skillName,
        title: skillTitle
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (primarySkills.length > 1) {
          primarySkills.splice(index, 1);
          this.cd.detectChanges();
        } else {
          this.toastr.error("At least one primary skill is mandatory and cannot be deleted.");
        }
      }
    });
  }
  deleteSecondarySkill(index: number, secondarySkill , secSkill: any) {
  const skillName = secSkill?.skill ? `${secSkill.skill} - Secondary Skill` : 'Secondary Skill';
  const skillTitle = secSkill?.skill ? `Delete Secondary Skill: ${secSkill.skill}` : 'Delete Secondary Skill';
    const dialogRef = this.dialog.open(DeleteDialogComponent, {
      width: auto,
      minWidth: '550px',
      height: auto,
      data: {
      name: skillName,
      title: skillTitle
      }
    })
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (secondarySkill.length > 1) {
          secondarySkill.splice(index, 1);
          this.cd.detectChanges();
        } else {
          this.toastr.error("At least one Secondary skill is mandatory and cannot be deleted.");
        }
      }
    });

  }
  deleteCertification(index: number, object: { name: any; }, certificates: any[]) {
    const dialogRef = this.dialog.open(DeleteDialogComponent, {
      width: auto,
      minWidth: '550px',
      height: auto,
      data: {
        name: "Certification",
        title: "Delete Certification",
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        certificates.splice(index, 1);
      }
    });
  }
  uploadCertificates(certification) {
    const certificateCategoryTypes = ["Certificate", "Invoice", "Certificate Tagging", "Others"];
    const selectedCertificateTypes = certification.certificateAttachment
      ? certification.certificateAttachment.map((attachment) => attachment.attachmentType)
      : [];

    const selectedFileNames = certification.certificateAttachment
      ? certification.certificateAttachment.map((attachment) => attachment.name)
      : [];

    const dialogRef = this.dialog.open(TemplateUploadModalComponent, {
      width: '870px',
      height:'466px',
      panelClass: 'view-file',
      data: { certificateCategoryTypes }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {

        certification.certificateAttachment = certification.certificateAttachment
          ? certification.certificateAttachment
          : [];

        result.forEach((x: {
          Name: any;
          FileExtension: any;
          MimeType: any;
          FileBase64: any;
          certificateCategory: any;
        }) => {
          const fileName = x.Name;
          const certificateCategory = x.certificateCategory;

          if (selectedFileNames.includes(fileName)) {
            this.toastr.warning("This file is already selected.");
            return;
          }


          var obj = {
            name: fileName,
            fileExtension: x.FileExtension,
            mimeType: x.MimeType,
            fileBase64: x.FileBase64,
            sharePointUrl: "",
            attachmentType: certificateCategory
          };

          certification.certificateAttachment.push(obj);
          selectedFileNames.push(fileName);
          selectedCertificateTypes.push(certificateCategory);
        });

        if (certification.certificateAttachment.find((c) => c.attachmentType == 'Certificate Tagging'))
          certification.hasCertificateTagging = true;
      }
    });
  }
  convertDate(inputDate) {
    let date = new Date(inputDate);
    return date.toISOString().split('T')[0];
  }
  getServiceAreasInfo(id, subCompetencies) {
    this.loading = true;
    this.getServiceAreas(id)
    this.employeeService.getServiceAreasInfo(id).subscribe(x => {
      this.serviceAreasInfo = x.data;
      subCompetencies?.forEach(s => {
        if (s.serviceAreas && s.serviceAreas.length > 0) {
          s.serviceAreas.forEach(sa => {
            if (sa.proficiency == 4) {
              this.clearServiceArea(sa);
            }
            else {
              this.convertExperience(sa);
            }
            let serviceArea = this.serviceAreasInfo?.find(si => si.name == sa.serviceArea);
            if (serviceArea && !sa.serviceAreaInfo) {
              sa.serviceAreaInfo = serviceArea.serviceAreaInfo;
            }
          })
        }
        else {
          s.serviceAreas = JSON.parse(JSON.stringify(this.serviceAreasInfo));
          s.serviceAreas.forEach(area => {
            this.clearServiceArea(area);
          })
        }
      })
      this.loading = false;
    })

  }
  getServiceAreas(competencyId: number) {
    this.employeeService.getServiceAreasInfo(competencyId).subscribe(x => {
      this.certificateServiceAreas = x.data;
    });
  }
  updateSkillsonServiceLine(competencyId, serviceLines, skills, key) {
    this.employeeService.getServiceAreasInfo(competencyId).subscribe(x => {
      let newServiceLines = x.data;
      serviceLines.forEach(s => {
        let serviceLineData = newServiceLines.find(sl => sl.name == s.serviceArea);
        if (serviceLineData) {
          s.id = serviceLineData.id;
        }
      })
      skills = skills.filter(s => s.serviceLineId == 0 || serviceLines.some(sl => sl.id === s.serviceLineId));
      this.primarySkills[key] = skills;
    });
  }
  clearServiceArea(area) {
    area.proficiency = 4;
    area.projectCount = "";
    area.experience = 0;
    area.experienceYears = "";
    area.experienceMonths = "";
    area.exposureCount = null;
    area.projectCount = null;
    area.isInvalidProjectRange = false;
    area.isInvalidExperienceRange = false;
    area.isInvalidExposureRange = false;
    area.isChecked = false;
  }
  initializeExperience(area: any) {
    if (area.experience != null) {
      area.experienceYears = Math.floor(area.experience);
      area.experienceMonths = Math.round((area.experience - area.experienceYears) * 12);
    }
  }
  validateSubCompetency(subCompetency): boolean {
    if (!this.validateAreas(subCompetency.serviceAreas)) {
      subCompetency.areaPanelState = true;
      return true;
    } else {
      subCompetency.areaPanelState = false;
    }
    let hasPrimarySkills = subCompetency.primarySkills?.length > 0;
    if (!hasPrimarySkills) {
      this.toastr.error("Please add at least one primary skill.");
      return true;
    }

    let hasSecondarySkills = subCompetency.secondarySkills?.length > 0;
    if (!hasSecondarySkills) {
      this.toastr.error("Please add at least one secondary skill.");
      return true;
    }

    this.allSkills = [...subCompetency.primarySkills, ...subCompetency.secondarySkills];
    subCompetency.skillPanelState = !this.validateSkills(this.allSkills, "all"); subCompetency.certificationPanelState = !this.validateCertification(subCompetency.certificates);
    // if (
    //   (subCompetency.primarySkills?.filter((s) => s.isCertified).length || 0) +
    //   (subCompetency.secondarySkills?.filter((s) => s.isCertified).length ||
    //     0) >
    //   subCompetency.certificates?.filter((c) => c.status === 3).length
    // ) {
    //   this.toastr.error("Please upload a certified certificate.");
    //   subCompetency.certificationPanelState = true;
    //   return true;
    // }
    return subCompetency.areaPanelState || subCompetency.certificationPanelState || subCompetency.skillPanelState;
  }
  deleteCertificateAttachment(certification, i) {
    certification.certificateAttachment.splice(i, 1);
    if (!certification.certificateAttachment.find(c => c.attachmentType == 'Certificate Tagging')) {
      certification.hasCertificateTagging = certification.certificateTagging = false;
    }
  }
  viewFile(url) {
    const dialogRef = this.dialog.open(ViewfileComponent, {
      width: "900px",
      height: "500px",
      panelClass: "view-file",
      data: { iFrameURL: url },
    });
    dialogRef.afterClosed().subscribe()
  }
  downloadResume(sharepointId, name) {
    this.employeeService.downloadResume(sharepointId).subscribe(res => {
      var url = res.message
      this.downloadFile(url, name);
    })
  }
  downloadFile(url, name) {
    let a = document.createElement("a");
    document.body.appendChild(a);
    a.href = url;
    a.download = String(name);
    a.click();
    a.remove();
  }
  donloadResumeFormat() {
    this.downloadFile('./../../../assets/files/Innova Format -Template.docx', 'Innova Format -Template.docx');
  }
  saveCompetency() {
    let isSubmitted = true;
    this.isAreasNotFilled = false;
    if (!this.employee.domains?.length) {
      this.toastr.error("Please select at least one vertical expertise");
      isSubmitted = false;
    } else if (
      this.subCompetency) {
      if (this.employee.competencies) {
        outerLoop: for (let i = 0; i < this.employee.competencies.length; i++) {
          let competency = this.employee.competencies[i];
          for (let j = 0; j < competency.subCompetencies.length; j++) {
            let subCompetency = competency.subCompetencies[j];
            if (subCompetency && this.validateSubCompetency(subCompetency)) {
              this.onSubCompetencyChange(subCompetency, competency.subCompetencies, true);
              this.prevCompetencyIndex = i;
              this.onCompetencyChange(null, true);
              isSubmitted = false;
              break outerLoop;
            }
            else {
              subCompetency.primarySkills.forEach(p => {
                this.calculateCombinedExperience(p);
              })
              subCompetency.secondarySkills.forEach(s => {
                this.calculateCombinedExperience(s);
              })
            }
          }
        }
      }
      if (isSubmitted && (this.employee.approvalStatus == 3 || this.employee.approvalStatus == 4)) {
        this.employeeService.approveEmployee(this.employee).subscribe(res => {

          if (this.employee.approvalStatus == 3) {
            this.toastr.success("Employee details approved successfully.");
          }
          else if (this.employee.approvalStatus == 4) {
            this.toastr.success("Employee details rejected successfully.");
          }
          setTimeout(() => {
            this._location.back();
            this.loading = false;
          }, 1000);
        }, error => {
          this.clickedApprovedOrRejected = false;
          this.loading = false;
          this.toastr.error("Something went wrong, Please try again.");
        })
      }
      else if (isSubmitted) {
        this.employeeService.draftEmployee(this.employee).subscribe(res => {
          this.toastr.success("Employee details Saved Successfully");
          this.backButton();
        }, error => {
          this.clickedApprovedOrRejected = false;
          this.loading = false;
          this.toastr.error("Something went wrong, Please try again.");
        })
      }
    }
  }

  rejectApproval() {
    this.dialog
      .open(CommentsDialogComponent, { data: { isApproved: false } })
      .afterClosed()
      .toPromise()
      .then((response) => {
        if (response) {
          this.employee.comments = response;
          this.employee.approvalStatus = 4;
          this.saveCompetency();
        }

      });
  }
  onInputCommentsChange() {
    this.commentsError = '';
  }

  approveApproval() {
    this.clickedApprovedOrRejected = true;
    this.approvedData = true;
    this.employee.approvalStatus = 3;
    this.saveCompetency();
  }
  getFilteredValues(event: any) {
    
    const specialCharsRegex = /[!#$%^&*_+\-=\[\]{};':"\\|,.<>\/?~]/;
    if (event == "") {
      this.currentEmployee = "";
      this.filteredValues = [];
      this.getEmployeeDetalis(this.empId);
    }
    if (event && specialCharsRegex.test(event)) {
      this.filteredValues = [];
    } else {
      this.employeeService.getEmployeesOnSearch(event).subscribe((res) => {
        this.filteredValues = res.data ? res.data.profiles : [];
      });
    }
  }

  setCurrentEmployee(value: any) {
    
    this.isSavebuttonvisible=this.loginemployeeId==value  || (this.role.includes(GsdRoles.SuperAdmin) || this.role.includes(GsdRoles.Admin))  ?true:false;
    
    this.isEmployeeSearch = true;
    this.employee = {}
    this.selectedTabIndex = 0;
    this.previousTabIndex = 0;
    this.sharedSkillService.setEmployeeId(value);
    this.getEmployeeDetalis(value)
  }

  onTabChange(subCompetency) {

    if (this.selectedTabIndex != this.previousTabIndex) {
      if (
        this.previousTabIndex === 0 &&
        !this.validateAreas(subCompetency.serviceAreas)
      ) {
        this.selectedTabIndex = this.previousTabIndex;
      } else if (
        this.previousTabIndex === 1 &&
        (!this.validateSkills(subCompetency.primarySkills, "primary") ||
          !this.validateSkills(subCompetency.secondarySkills, "secondary"))
      ) {
        this.selectedTabIndex = this.previousTabIndex;
      } else if (
        this.previousTabIndex === 2 &&
        (!this.validateCertification(subCompetency.certificates))
      ) {
        this.selectedTabIndex = this.previousTabIndex;
      } else {
        this.previousTabIndex = this.selectedTabIndex;
      }
    }
  }
  clearSelectedAreas() {
    this.subCompetency.serviceAreas.forEach(area => {
      if (area.isChecked) {
        this.clearServiceArea(area);
      }
    });
  }
}
